/**
 * The Studio's entry.
 *
 * The two stylesheets load here, in order: the foundation first, then the Studio's
 * extension. Nothing else in the app imports CSS.
 */

import '@atlas-nook/design-system/tokens.css';
import '@atlas-nook/design-system/studio.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';

const root = document.getElementById('root');
if (root === null) throw new Error('index.html is missing #root');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
